export default "__VITE_ASSET__$4XWzhEa__"